import { motion } from "framer-motion"
import { BtnMenu, Menu } from "../../components/home/_menu";
import { useContext } from "react";
import { DataContext } from "../../context/dataContext";
import AnimateLoader from "../../components/AnimateLoader";
import List from "../../components/home/List";
import { Before, Next } from "../../components/home/Next";
import Footer from "../admin/Footer";


const Filter = ({ open, setOpen }) => {

    const { data } = useContext(DataContext);

    if (data === null) {
        return <AnimateLoader />;
    }

    return (
        <>
            <BtnMenu open={open} setOpen={setOpen} />
            {open && <Menu open={open} setOpen={setOpen} />}
            <motion.div

                style={{ overflowY: "scroll" }}
                className="w-100 h-100 d-flex flex-column p-md-5 mx-md-5"
                initial={{ x: "200%" }}
                animate={{ x: 0 }}

            >
                <div className="container d-flex flex-column  align-items-center mt-4 pt-5 pt-md-0 h-100">
                    <div className="col-md-9 col-12">
                        <strong className="fs-1">web developer portafolio</strong>
                        <p className="fw-normal">
                            From Web Components and UI/UX animations to React.JS, Redux, and Node.JS. Check out my latest web software development portfolio projects.
                        </p>
                        <p> <small>Showing all  proyects</small></p>
                        <List data={data} />
                    </div>

                    <Footer />
                </div>

            </motion.div>
            <Next name="lab" link="/lab" />
            <Before name="About" link="/" />



        </>

    )
}
export default Filter;